import {OtsBadge} from "../components/OtsBadge";
import {processStatusLabel, processStatusTone} from "./process-ui";

export type ProcessStatusBadgeProps = {
  status: string;
  /** Shown instead of the status while a cancel is pending. */
  cancelRequested?: boolean;
  /** A clean finish with nothing to report reads as "No records" rather than "Done". */
  noRecords?: boolean;
  className?: string;
};

/** A process's status in words and colour; running shows a pulsing dot. */
export const ProcessStatusBadge = ({status, cancelRequested = false, noRecords = false, className}: ProcessStatusBadgeProps) => {
  const canceling = cancelRequested && status === "RUNNING";
  const empty = noRecords && status === "SUCCEEDED";

  return <OtsBadge
    size="compact"
    tone={canceling || empty ? "neutral" : processStatusTone(status)}
    dot={status === "RUNNING" || status === "QUEUED"}
    className={[status === "RUNNING" && !canceling ? "[&>span:first-child]:animate-pulse motion-reduce:[&>span:first-child]:animate-none" : "", className]
      .filter(Boolean).join(" ")}>
    {canceling ? "Canceling" : empty ? "No records" : processStatusLabel(status)}
  </OtsBadge>;
};
